// Storefront alan adı güvenliği — slug (subdomain) + custom domain doğrulaması.
// ⚠️ Bu listeler backend WidgetService.php (RESERVED_SLUGS / OWNED_DOMAIN_SUFFIXES) ile AYNI kalmalı.

// Sistem/rezerve subdomain'ler — storefront slug'ı OLAMAZ (app.tourzone.com vb. ile çakışma + güvenlik).
export const RESERVED_SLUGS = [
    'app', 'apps', 'api', 'apiv2', 'apiv3', 'apiv4', 'gateway', 'www', 'panel', 'admin', 'adminv2',
    'store', 'storefront', 'partner', 'partners', 'partnersv2', 'partnersv3', 'partnersv4',
    'mail', 'smtp', 'imap', 'pop', 'ftp', 'cdn', 'static', 'assets', 'img', 'images', 'media',
    'ns1', 'ns2', 'dns', 'mx', 'dashboard', 'dev', 'test', 'staging', 'stage', 'prod', 'production',
    'status', 'webhook', 'webhooks', 'widget', 'embed', 'auth', 'login', 'logout', 'account',
    'system', 'root', 'help', 'support', 'docs', 'blog', 'tourzone', 'holideus',
    // Holideus panel host'ları — storefront slug'ı DEĞİL, panel açmalı.
    'holideusv2', 'holideusv3', 'holideusv4',
    // Yalnız frontend tarafında anlamlı (backend slug listesinde gereksiz ama zararsız).
    'localhost',
]

// Bize ait / yönetilen alan adları — customDomain OLAMAZ (tourzone.com subdomain'i = slug mekanizması).
export const OWNED_DOMAIN_SUFFIXES = ['tourzone.com', 'tourzone.dev', 'holideus.ru', 'pages.dev', 'workers.dev']

export const isReservedSlug = (s) => RESERVED_SLUGS.includes(String(s || '').trim().toLowerCase())

export const isOwnedDomain = (h) => {
    h = String(h || '').trim().toLowerCase()
    return OWNED_DOMAIN_SUFFIXES.some((suf) => h === suf || h.endsWith('.' + suf))
}
